import {useEffect, useRef, useState} from 'react'
import {SActionBtn, SDrawerOrModal, SGeneralForms, SLowcodeList, SMessage, STableActions,} from 'shj-components'
import {config} from './config'
import { searchDiagramReviewConfig, addDiagramReviewConfig, editDiagramReviewConfig, deleteDiagramReviewConfig, getVerifyStateEnum } from '@/services/order';
import {apiData2Table, trimStr} from '@/utils/data.ts'
import { getBudgetTypeEnumNew } from '@/services/goods'
import {getBizOpTypeEnum} from "@/services/customerServices.ts";
import { getBusinessDictList } from '@/services/product';
import {message, Switch} from 'antd'
import {isEmpty} from 'lodash-es'
import {httpOrgList} from "@/services/homeService.ts";

export default function ImageProcess() {
  const listRef = useRef()
  const formRef = useRef()
  const [open, setOpen] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [record, setRecord] = useState({})
  const [enumObj, setEnumObj] = useState({})

  useEffect(() => {
    if (!isEmpty(record)) formRef.current?.onFormRef().setFieldsValue(record)
    return () => {
      formRef.current?.onFormRef().resetFields()
    }
  }, [record])

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      searchDiagramReviewConfig({
        params: {pageId: current, pageSize},
        data: {
          ...query,
        },
      })
        .then((res: any) => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return deleteDiagramReviewConfig(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  /*const onChangeStatus = (enabled: boolean, id: string) => {
    return brandUpdateState({enabled, idList: [id]}).then((res: any) => {
      message.success(res.message || '操作成功')
      listRef.current?.reload()
    })
  }*/

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? editDiagramReviewConfig : addDiagramReviewConfig
        apiUrl({...values, enabled: values.enabled || false})
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    // 报价类型
    const budgetRes: any = await getBudgetTypeEnumNew()
    const demandRes: any = await getBizOpTypeEnum()
    const receiptRes: any = await getBusinessDictList({ data: { priKey: 'receiptType', enabled: true } });
    const verifyRes: any = await getVerifyStateEnum()

    setEnumObj({
      companyList,
      budgetList: budgetRes,
      demandList: demandRes, 
      receiptList: receiptRes?.[0]?.children?.map(item => ({ label: item?.label, value: item?.object?.priKey })) || [],
      verifyList: verifyRes,
    })

    return Promise.resolve({
      companyList,
      budgetList: budgetRes,
      demandList: demandRes,
      receiptList: receiptRes?.[0]?.children?.map(item => ({ label: item?.label, value: item?.object?.priKey })) || [],
      verifyList: verifyRes,
    })
  }

  const extensions = {
    request: {fetchList, getOptions},
    events: {
      onAdd,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            // onClick={checked => onChangeStatus(checked, record.id)}
            disabled={true}
          />
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)} auth="nodeConfigAdd">
              编辑
            </SActionBtn>
            <SActionBtn disabled={record.enabled} danger onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={'新增图审配置'}
        mode="drawer"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          configs={[
            {
              formItem: [
                {label: 'id', name: 'id', hidden: true},
                {
                  label: '适用门店',
                  name: 'shopIds',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '适用门店不能为空'}],
                  type: 'select',
                  comConfig: {
                    mode: 'multiple',
                    options: enumObj?.companyList,
                    fieldNames: {label: 'name', value: 'id'}
                  }
                },
                {
                  label: '适用报价类型',
                  name: 'budgetTypes',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '适用报价类型不能为空'}],
                  type: 'select',
                  comConfig: {
                    mode: 'multiple',
                    options: enumObj?.budgetList,
                    fieldNames: {label: 'name', value: 'code'}
                  }
                },
                {
                  label: '适用需求标签',
                  name: 'bizTags',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '适用需求标签不能为空'}],
                  type: 'select',
                  comConfig: {
                    mode: 'multiple',
                    options: enumObj?.demandList,
                    fieldNames: {label: 'description', value: 'key'}
                  }
                },
                {
                  label: '收款类型',
                  name: 'receiptType',
                  spanCol: 24,
                  type: 'select',
                  comConfig: {
                    options: enumObj?.receiptList,
                    fieldNames: {label: 'label', value: 'value'}
                  }
                },
                {
                  label: '核销状态',
                  name: 'verifyStates',
                  spanCol: 24,
                  type: 'select',
                  comConfig: {
                    mode: 'multiple',
                    options: enumObj?.verifyList,
                    fieldNames: {label: 'description', value: 'key'}
                  }
                },
                {
                  spanCol: 8,
                  label: '状态',
                  name: 'enabled',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '启用',
                    unCheckedChildren: '禁用',
                  },
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
}
